// @flow
import React from "react";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { config } from "@fortawesome/fontawesome-svg-core";
import FontAwesomeIcon from "../FontAwesomeIcon";
import getSizeClass from "../../../helpers/getFontAwesomeSizeClassname";

config.autoAddCss = false;

type Props = {
  size?: 14 | 16 | 24 | 32 | 40 | 48,
  className?: string
};

const Twitter = ({ size, className = "" }: Props) => {
  const sizeClass = getSizeClass(size);

  return (
    <div className={`${sizeClass} ${className}`}>
      <FontAwesomeIcon icon={faTwitter} className={sizeClass} />
    </div>
  );
};

export default Twitter;
